<template>
  <transition name="fade">
    <div class="mod-req-app-tkdn">
      <div class="mod-req-app-container-tkdn">
        <div class="btn-close" @click="closeModal()">
          X
        </div>
        <div class="title-wrapper">
          <div class="title-big title-color__red">
            Import Data
          </div>
        </div>

        <div class="half-input-wrapper">
          <div class="hiw-label">Date Range</div>
          <div class="hiw-multiple">
            <input class="hiw-2-row" type="date" v-model="poStartDate" />
            <input class="hiw-2-row" type="date" v-model="poEndDate" />
          </div>
        </div>

        <div>
          <div class="half-input-wrapper">
            <div class="hiw-label">Business Unit</div>
            <div class="hiw-multiple">
              <!-- <div>
                <input type="radio" value="ALL" v-model="type" class="mr10" />
                <label>All</label>
              </div> -->
              <div>
                <input type="radio" value="BCE" v-model="type" class="mr10" />
                <label>BCE</label>
              </div>
              <div>
                <input type="radio" value="GEMS" v-model="type" class="mr10" />
                <label>GEMS</label>
              </div>
            </div>
          </div>
        </div>

        <div class="half-input-wrapper" v-if="type != 'ALL'">
          <div class="hiw-label">Detail Company</div>
          <div class="hiw-multiple">
            <v-select class="style-chooser" :placeholder="`Cari ${type}`" label="label" :options="companyCode"
              v-model="choosedCompany" />
          </div>
        </div>

        <div>
          <div class="half-input-wrapper">
            <div class="hiw-label">Table Download</div>
            <div class="hiw-multiple">
              <div>
                <input type="radio" value="actual" v-model="table" class="mr10" />
                <label>Actual</label>
              </div>
              <div>
                <input type="radio" value="validate" v-model="table" class="mr10" />
                <label>Validate</label>
              </div>
            </div>
          </div>
          <div class="pointer" @click="generateTemplate">
            <i class="fas fa-download"></i> Download Template
          </div>
          <div>
            <label class="pointer">
              <i class="fas fa-upload"></i>
              {{ theFileName }}
              <input type="file" style="display: none;" @change="fileChangeHandler" />
            </label>
          </div>
        </div>
      </div>

      <div class="one-btn-right" style="position: absolute; width: 70%; bottom:5%; right:0; padding:0 4%">
        <div class="btn-big">
          <div :class="`btn-wrapper ${theFileName !== 'Upload Template'
            ? 'btn-wrapper__red'
            : 'btn-wrapper__gray'
            }`
            " @click="submit()">
            Confirm
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
import * as XLSX from 'sheetjs-style'
export default {
  data() {
    return {
      table: 'actual',
      vendors: [],
      pic: '',
      type: null,
      name: '',
      phone: '',
      email: '',
      note: null,
      timeout: null,
      choosedCompany: '',
      companyCode: [],
      type: 'ALL',
      poStartDate: '',
      poEndDate: '',
      files: [],
    }
  },
  computed: {
    theFileName() {
      if (this.files.length > 0 && 'name' in this.files[0]) {
        return this.files[0].name
      } else {
        return 'Upload Template'
      }
    },
    choosedVendor: {
      get() {
        return this.$store.state.myRequest.choosedVendor
      },
      set(newValue) {
        this.$store.commit('myRequest/SET_DATA', {
          name: 'choosedVendor',
          value: newValue,
        })
      },
    },
  },
  watch: {
    type: function (value) {
      switch (value) {
        case 'BCE':
          this.getBcCompanyCode()
          break
        case 'GEMS':
          this.getGemsCompanyCode()
          break

        default:
          break
      }
    },
  },
  methods: {
    checkForm() {
      let arr = [
        [this.choosedVendor, 'Nama Vendor'],
        [this.pic, 'Nama PIC'],
        [this.type, 'Type Praqualifikasi'],
        [this.phone, 'Nomor Telepon PIC'],
        [this.isEmailValid(this.email), 'Email PIC'],
      ]

      return this.multiConditions(arr)
    },
    async submit() {
      if (this.theFileName !== 'Import template') {
        const url = `${api}/api/v1/po/import-po`
        this.startDownload()
        try {
          if (this.files && this.files.length > 0) {
            let bodyFormData = new FormData()
            bodyFormData.append('template', this.files[0])
            bodyFormData.append(
              'role_id',
              this.$get(this.$store, 'state.role_id')
            )

            const { data } = await axios({
              method: 'POST',
              url,
              data: bodyFormData,
              headers: { 'Content-Type': 'multipart/form-data' },
            })

            if (data && data.status == 'success') {
              this.finishDownload()
              alert(data.message)
              await this.$store.dispatch('tkdnStore/getRealisasiBelanja')
              await this.$store.dispatch('tkdnStore/getBelanjaDomestik')
              await this.$store.dispatch('tkdnStore/getTkdnCategories')
            }
          } else {
            this.finishDownload()
            alert('Silahkan masukkan file template.xslx terlebih dahulu')
          }
        } catch (error) {
          this.$store.commit('SET_GLOBAL_LOADING', false)
          this.$store.commit(
            'SET_NOTIF',
            this.$get(error, 'response.data.message', 'Error')
          )
        }
      }
    },
    closeModal() {
      this.$store.commit('tkdnStore/UPDATE_TKDN_DATA', {
        name: 'importModalShow',
        value: false,
      })
    },
    fileChangeHandler(e) {
      let files = Array.from(e.target.files)
      let fileType = files[0]['type']
      let fileName = files[0]['name']

      if (fileName.search(/xlsx/gi) >= 0) {
        this.files = files
      } else {
        alert('Jenis File ini tidak dapat di upload')
      }
    },
    async downloadTemplate() {
      try {
        await this.startDownload()
        let url = `${api}/api/v1/po/download?table=${this.table}`
        let start = this.poStartDate
        let end = this.poEndDate
        let company = this.choosedCompany

        if (start && start != '' && end && end != '') {
          url += `&end=${end}&start=${start}`
        }

        if (company && company.id) {
          url += `&company=${company.id}`
        }

        if (this.type == 'BCE') {
          url += `&server=BCE`
        }

        if (this.type == 'GEMS') {
          url += `&server=GEMS`
        }

        const { data } = await axios({
          url,
          method: 'GET',
        })

        if (data && data.status == 'success') {
          this.finishDownload()
          return data.data
        }
      } catch (error) {
        this.finishDownload()
      }
    },

    async getGemsCompanyCode() {
      try {
        const url = `${api}/api/v1/dashboard/company`
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          this.companyCode = await data.data.map(item => {
            return {
              id: item.kode,
              label: `${item.nama_perusahaan}${item.badan_usaha && item.badan_usaha != ''
                ? `, ${item.badan_usaha}`
                : ''
                }`,
            }
          })

          this.companyCode = await this.companyCode.filter(
            item => item.id != 2000
          )
          this.companyCode.unshift({
            id: 'all',
            label: 'All',
          })
        }
      } catch (error) {
        // do nothing
      }
    },

    async getBcCompanyCode() {
      try {
        const url = `${api}/api/v1/company-code-bc?page=1&limit=10`
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          this.companyCode = await data.data.map(item => {
            return {
              id: item.kode,
              label: `${item.nama_perusahaan}${item.badan_usaha && item.badan_usaha != ''
                ? `, ${item.badan_usaha}`
                : ''
                }`,
            }
          })

          this.companyCode.unshift({
            id: 'all',
            label: 'All',
          })
        }
      } catch (error) {
        // do nothing
      }
    },
    startDownload() {
      this.$store.commit('SET_GLOBAL_LOADING', true)
    },
    finishDownload() {
      this.$store.commit('SET_GLOBAL_LOADING', false)
      this.closeModal()
    },
    async generateTemplate() {
      if (this.type != 'BCE' && this.type != 'GEMS') {
        alert(`Silahakan pilih Bisnis Unit terlebih dahulu, ${this.type}`)
        return true
      }
      try {
        let dataPo = await this.downloadTemplate()

        if (dataPo && dataPo.length > 0) {
          let po = XLSX.utils.json_to_sheet(dataPo)

          var wb = XLSX.utils.book_new()

          XLSX.utils.book_append_sheet(wb, po, 'PO')

          const numberCell = {
            numFmt: '0.00',
          }

          for (let i in dataPo) {
            let cell = Number(i) + 2
            po[`M${cell}`].s = numberCell
            po[`N${cell}`].s = numberCell
            po[`O${cell}`].s = numberCell
            po[`Q${cell}`].s = numberCell
            po[`R${cell}`].s = numberCell
            po[`S${cell}`].s = numberCell
            po[`T${cell}`].s = numberCell
            po[`X${cell}`].s = numberCell
          }

          XLSX.writeFile(wb, 'template.xlsx') // name of the file is 'book.xlsx'
        } else {
          alert('Data PO tidak di temukan')
        }
      } catch (error) {
        // do nothing
      }
    },
  },
}
</script>
